import React, { useEffect, useState } from 'react';
import { sortBy, prop } from 'ramda';
import { connect } from 'react-redux';
import {
    notifyError as notifyErrorAction,
    notifySuccess as notifySuccessAction,
} from '../../../../actions/reduxActions/notification';
import {
    dismissMapElementConfig,
    saveMapElement,
} from '../../../../actions/reduxActions/mapElements';
import graphSources from '../../../../sources/graph';
import Loader from '../../../Loader';
import OperatorPanel from './OperatorPanel';
import { OperatorProvider } from './OperatorProvider';
import { isNullOrEmpty } from '../../../../utils/core';
import modelUtils from '../../../../utils/model';

export const Operator = ({
    id: mapElementId,
    flowId,
    editingToken,
    elementType,
    x,
    y,
    tenantId,
    authenticationToken,
    notifyError,
    notifySuccess,
    cancel,
    save,
}) => {
    const [mapElement, setMapElement] = useState(null);

    const fetchMapElement = () =>
        graphSources
            .getMapElement(mapElementId, flowId, editingToken, 'map', tenantId, authenticationToken)
            .then((mapElementResponse) => {
                // Ensure the operations are ordered by their 'order' property
                mapElementResponse.operations = sortBy(
                    prop('order'),
                    mapElementResponse?.operations ?? [],
                );
                setMapElement(mapElementResponse);
            })
            .catch(notifyError);

    useEffect(() => {
        if (!isNullOrEmpty(mapElementId)) {
            fetchMapElement();
        } else {
            // Create a new map element
            setMapElement({
                id: modelUtils.guid(),
                developerName: '',
                operations: [],
                elementType,
                x,
                y,
            });
        }
    }, []);

    if (mapElement === null) {
        return <Loader />;
    }

    return (
        <OperatorProvider
            mapElement={mapElement}
            editingToken={editingToken}
            authenticationToken={authenticationToken}
            tenantId={tenantId}
            flowId={flowId}
            cancel={cancel}
            save={save}
            notifyError={notifyError}
            notifySuccess={notifySuccess}
        >
            <OperatorPanel />
        </OperatorProvider>
    );
};

export default connect(
    ({ currentUser }) => ({
        tenantId: currentUser.tenantId,
        authenticationToken: currentUser.authenticationToken,
    }),
    {
        cancel: dismissMapElementConfig,
        save: saveMapElement,
        notifyError: notifyErrorAction,
        notifySuccess: notifySuccessAction,
    },
)(Operator);
